import request from '@/utils/ajax'

export function getWechatPublicNoMsgTplList(data) {
  return request({
    url: '/wx/manage/msgTemplate/listWithoutCookie',
    method: 'get',
    params:data
  })
}

export function getTelegramRobitList(data) {
    return request({
        url: '/wx/manage/tgBotConfig/list',
        method: 'get',
        params:data
    })
}

export function getLarkRobitList(data) {
    return request({
        url: '/wx/manage/larkAppConfig/list',
        method: 'get',
        params:data
    })
}

export function getFeishuRobitList(data) {
    return request({
        url: '/wx/manage/larkBotConfig/list',
        method: 'get',
        params:data
    })
}

export function getEnterpriseWeChatRobitList(data) {
    return request({
        url: '/wx/manage/qywxBotConfig/list',
        method: 'get',
        params:data
    })
}

export function queryTagsList(data) {
    return request({
        url: '/wx/manage/wxUserTags/listWithoutCookie',
        method: 'get',
        params:data
    })
}


export function saveMessagePushRule(data) {
    return request({
        url: '/wx/manage/spiderArticlePublish/save',
        method: 'post',
        data: data
    })
}

export function editMessagePushRule(data) {
    return request({
        url: '/wx/manage/spiderArticlePublish/update',
        method: 'put',
        data: data
    })
}

export function deleteMessagePushRule(data) {
    return request({
        url: '/wx/manage/spiderArticlePublish/delete',
        method: 'post',
        data: data
    })
}
